export default "__VITE_ASSET__HHijLEaI__"